<div class="invoices-preview-container">
  <div *ngIf="loading" class="flex justify-content-center align-items-center" style="min-height: 400px;">
    <p-progressSpinner></p-progressSpinner>
  </div>

  <div *ngIf="!loading && record">
    <div class="flex justify-content-between align-items-center mb-4">
      <div>
        <span class="text-2xl font-bold">Facture {{ record?.invoice_ref || record?.invoice_number || record?.id }}</span>
      </div>
      <div class="flex gap-2 flex-wrap">
        @if (hasOnlinePayment) {
          <p-button
            size="small"
            icon="fa-light fa-credit-card"
            label="Payer en ligne"
            severity="success"
            [loading]="paying"
            (click)="payOnline()">
          </p-button>
        }
        <p-button
          size="small"
          icon="fa-light fa-download"
          label="Télécharger PDF"
          severity="secondary"
          [outlined]="true"
          (click)="downloadPDF()"
          [disabled]="!pdfUrlRaw">
        </p-button>
      </div>
    </div>

    <div class="pdf-viewer-container" *ngIf="pdfUrlRaw">
      <div *ngIf="loadingPdf" class="flex justify-content-center align-items-center" style="height: 600px;">
        <div class="text-center">
          <p-progressSpinner></p-progressSpinner>
          <p class="mt-3 text-muted">Chargement du PDF...</p>
        </div>
      </div>
      <pdf-viewer
        *ngIf="pdfBlobUrl && !loadingPdf"
        [src]="pdfBlobUrl"
        [render-text]="true"
        [original-size]="false"
        [show-all]="true"
        [zoom]="1"
        [zoom-scale]="'page-width'"
        style="display: block; width: 100%; height: calc(100vh - 300px); min-height: 600px;">
      </pdf-viewer>
    </div>

    <div *ngIf="!pdfUrlRaw" class="pdf-empty-state">
      <div class="empty-state-content">
        <i class="fa-light fa-file-pdf"></i>
        <h3>PDF non disponible</h3>
        <p>Le fichier PDF n'est pas disponible pour cette facture.</p>
      </div>
    </div>

    <div class="sticky-actions flex justify-content-center gap-2 p-4 bg-white border-top-1 border-gray-200 mt-4">
      @if (hasOnlinePayment) {
        <p-button
          icon="fa-light fa-credit-card"
          label="Payer en ligne"
          severity="success"
          [loading]="paying"
          (click)="payOnline()">
        </p-button>
      }
      <p-button
        icon="fa-light fa-download"
        label="Télécharger PDF"
        severity="secondary"
        [outlined]="true"
        (click)="downloadPDF()"
        [disabled]="!pdfUrlRaw">
      </p-button>
    </div>
  </div>

  <div *ngIf="!loading && !record" class="flex justify-content-center align-items-center" style="min-height: 400px;">
    <div class="text-center">
      <i class="fa-light fa-exclamation-triangle text-6xl text-red-500 mb-3"></i>
      <h3>Facture introuvable</h3>
      <p class="text-muted">La facture demandée n'existe pas ou n'est plus disponible.</p>
    </div>
  </div>
</div>
